
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("2DOhW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.init = void 0;

var $1ec63b7ef6229c92$var$_jquery = $1ec63b7ef6229c92$var$_interopRequireDefault((parcelRequire("4kMWr")));
function $1ec63b7ef6229c92$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $1ec63b7ef6229c92$var$init = module.exports.init = function init() {
    (0, $1ec63b7ef6229c92$var$_jquery["default"])(".backtotop").on("click", function() {
        return (0, $1ec63b7ef6229c92$var$_jquery["default"])("html:not(:animated),body:not(:animated)").animate({
            scrollTop: 0
        }, "normal"), !1;
    });
};

});


//# sourceMappingURL=backToTop.module.1b73c715.js.map
